/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import BookingStepItem from "../booking/steps/BookingStepItem";
import Skeleton from "./Skeleton";
import SkeletonText from "./SkeletonText";

const StyledItem = styled((props) => <BookingStepItem {...props} />)`
  padding: 12px;
`;

const SkeletonImage = styled(Skeleton)`
  width: 150px;
  height: 150px;
  border-radius: 8px;
  flex-shrink: 0;

  ${({ theme }) => theme.containerMedia.sm} {
    width: 90px;
    height: 90px;
  }
`;

const ItemInner = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  ${({ theme }) => theme.containerMedia.sm} {
    align-items: start;
  }
`;

const SkeletonItemMain = styled.div`
  display: grid;
  gap: 0.125rem;
  width: 100%;
`;

const SkeletonInfoList = styled.div`
  display: grid;
  gap: 0.125rem;
  margin-top: 8px;
`;

const LocationItemSkeleton = () => {
  return (
    <StyledItem>
      <ItemInner>
        <SkeletonImage />
        <SkeletonItemMain>
          <SkeletonText size="h3" width="60%" />
          <SkeletonText size="small" lines={2} />
          <SkeletonInfoList>
            <SkeletonText size="small" width="50%" />
            <SkeletonText size="small" width="35%" />
          </SkeletonInfoList>
        </SkeletonItemMain>
      </ItemInner>
    </StyledItem>
  );
};
export default LocationItemSkeleton;
